export default __webpack_public_path__ + "static/media/425-4256407_anime-pokemon-png-transparent-image-fat-pikachu-png.5d8202ba.png";